module.exports = __webpack_public_path__ + "img/logo10.1a617649.png";